import { Component, Inject, OnInit } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { HttpService } from "services";
import { UtilityService } from "services/utility.service";

@Component({
  selector: "alert-message-dialog",
  templateUrl: "./alert-message.component.html",
  styles: [
    "p{text-align: justify}",
    ".content-wrap{max-height:60vh;overflow-y:auto;margin-bottom:2rem}",
  ],
})
export class AlertMessageComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data, private snackbar: MatSnackBar,
    public dialogRef: MatDialogRef<AlertMessageComponent>, private http: HttpService) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
